import { AxiosInstance } from "axios";
import { surveyLocalization, SurveyModel } from "survey-core";
import markdownit from "markdown-it";

const md = markdownit({ linkify: true, breaks: true });

// Surveys can be embedded in an iframe, so links must escape it.
md.renderer.rules.link_open = (tokens, idx, options, _env, self) => {
  tokens[idx].attrSet("target", "_blank");
  tokens[idx].attrSet("rel", "noopener noreferrer");
  return self.renderToken(tokens, idx, options);
};

export const registerDefaults = (survey: SurveyModel, api: AxiosInstance) => {
  survey.api = api;
  survey.questionErrorLocation = "bottom";
  survey.showNavigationButtons = false;
  survey.getRowWrapperComponentName = () => "sv-row-wrapper-rd";
  surveyLocalization.defaultLocale = "nl";
  surveyLocalization.locales["nl"].requiredError = "Dit veld is verplicht.";

  survey.onTextMarkdown.add((_sender, options) => {
    const html = md.renderInline(options.text);
    if (html !== options.text) {
      options.html = html;
    }
  });
};
